import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { InputText } from 'primeng/inputtext'

import { CloseIconComponent } from '@ti/core/icons/close'
import { WarningIconComponent } from '@ti/core/icons/warning'
import { XCircleIconComponent } from '@ti/core/icons/x-circle'
import { PrefixedInputComponent } from '@ti/core/ui-kit/layout/components/inputs/prefixed-input'

import { UserFormMode } from '../../models/user-form.model'

type CredentialsForm = FormGroup<{
  username: FormControl<string | null>
  password: FormControl<string | null>
}>

@Component({
  selector: 'app-user-credentials-form',
  templateUrl: 'credentials-form.component.html',
  styleUrls: ['credentials-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CloseIconComponent,
    InputText,
    PrefixedInputComponent,
    ReactiveFormsModule,
    TranslatePipe,
    WarningIconComponent,
    XCircleIconComponent,
  ],
})
export class CredentialsFormComponent {
  public readonly closed = output()

  public readonly form = input<CredentialsForm>()
  public readonly mode = input<UserFormMode>()
  public readonly isEditMode = input<boolean>(false)
  public readonly usernameError = input<string>()
  public readonly usernamePrefix = input<string>()

  protected readonly TYPES = { UserFormMode }
}
